import { Text } from '@belong/ui';
import { POST_INSPECTION_FLOW_STRINGS } from 'strings/post-inspection-flow';

const BLOCK_ICONS: Record<string, string> = {
  'resident-focused-review':
    '/icons/move-in-on-track/resident-focused-review.svg',
  'nothing-slips-through': '/icons/move-in-on-track/nothing-slips-through.svg',
  'protect-move-in-date': '/icons/move-in-on-track/protect-move-in-date.svg',
  'flexible-payment': '/icons/move-in-on-track/flexible-payment.svg',
};

export function MoveInOnTrack() {
  return (
    <div className="mb-3xl">
      <Text
        variant="h3"
        fontWeight="semibold"
        className="mb-xs text-center md:text-left"
      >
        {POST_INSPECTION_FLOW_STRINGS['move_in_on_track.title']}
      </Text>
      <Text variant="p1" className="mb-xl text-center md:text-left">
        {POST_INSPECTION_FLOW_STRINGS['move_in_on_track.body']}
      </Text>
      <div className="grid grid-cols-1 gap-lg sm:grid-cols-2 sm:gap-x-lg sm:gap-y-2xl">
        {POST_INSPECTION_FLOW_STRINGS['move_in_on_track.blocks'].map(
          (block) => (
            <div key={block.key} className="flex flex-col">
              {BLOCK_ICONS[block.key] && (
                <img
                  alt=""
                  src={BLOCK_ICONS[block.key]}
                  width={60}
                  height={60}
                  className="mb-2sm h-[60px] w-[60px] object-contain"
                />
              )}
              <Text fontWeight="semibold" className="mb-2xs">
                {block.title}
              </Text>
              <Text variant="p1">{block.body}</Text>
            </div>
          ),
        )}
      </div>
    </div>
  );
}
